import { api } from '@sentinel/web-core';
import type { DrawnRadarLayer, MissionWeather, RadarFrames, WindField } from '@sentinel/shared';

const base = (missionId: string) => `/missions/${missionId}/weather`;

/** The weather of a mission (ADR 0021): at its centre, the wind of the view, the radar loops. */
export const weatherEndpoints = {
  mission: (missionId: string) => api<MissionWeather>(base(missionId)),
  wind: (missionId: string, bbox: string) =>
    api<WindField>(`${base(missionId)}/wind?bbox=${encodeURIComponent(bbox)}`),
  radarFrames: (missionId: string, layer: DrawnRadarLayer) =>
    api<RadarFrames>(`${base(missionId)}/radar/${layer}`),
  radarFrame: (missionId: string, layer: DrawnRadarLayer, time: number) =>
    api<Blob>(`${base(missionId)}/radar/${layer}/frames/${String(time)}`, { as: 'blob' }),
};
